export default{
  category: [
    {
      type: 'category',
      itemKey: 'LOVE',
      text: '#연애/사랑',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'TRAVEL',
      text: '#여행',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'FASHION',
      text: '#패션/뷰티',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'FOOD',
      text: '#음식',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'MUSIC',
      text: '#음악',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'MOVIE',
      text: '#영화',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'DRAMA',
      text: '#드라마/예능',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'HEALTH',
      text: '#건강/다이어트',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'ENTERTAINER',
      text: '#연예인',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'GAME',
      text: '#게임',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'SPORTS',
      text: '#스포츠',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'CAR',
      text: '#자동차/IT',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'BUSINESS',
      text: '#앱/비지니스',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'POLITICS',
      text: '#정치/경제/사회',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'BOOK',
      text: '#책/문화',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'DESIGN',
      text: '#예술/디자인',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'PRODUCT',
      text: '#제품/리빙',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'HOBBY',
      text: '#일상/취미',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'PET',
      text: '#반려동물',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'COMIC',
      text: '#만화/캐릭터',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'QUIZ',
      text: '#퀴즈/유머',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'SCHOOL',
      text: '#학교생활',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'THINKING',
      text: '#잡생각',
      flexRatio: 3
    },
    {
      type: 'category',
      itemKey: 'ETC',
      text: '#기타',
      flexRatio: 3
    }
  ],
  toward: [
    {
      type: 'toward',
      itemKey: 0,
      text: '폴라이드 유저 모두',
      flexRatio: 2
    },
    {
      type: 'toward',
      itemKey: 1,
      text: '내 팔로워만',
      flexRatio: 2
    }
  ],
  gender: [
    {
      type: 'gender',
      itemKey: 2,
      text: '남성여성 모두',
      flexRatio: 3
    },
    {
      type: 'gender',
      itemKey: 0,
      text: '남성',
      flexRatio: 3
    },
    {
      type: 'gender',
      itemKey: 1,
      text: '여성',
      flexRatio: 3
    }
  ],
  job: [
    {
      type: 'job',
      itemKey: -1,
      engText: 'ALL',
      text: '모두',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 0,
      engText: 'STUDENT',
      text: '초/중/고생',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 1,
      engText: 'COLLEGE',
      text: '대학(원)생',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 2,
      engText: 'STARTUP',
      text: '스타트업',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 3,
      engText: 'EMPLOYEE',
      text: '회사원',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 4,
      engText: 'FUNCTIONARY',
      text: '공무원',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 5,
      engText: 'SELFEMPLOYED',
      text: '자영업자',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 6,
      engText: 'PROFESSION',
      text: '전문직',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 7,
      engText: 'HOMEMAKER',
      text: '주부',
      flexRatio: 5
    },
    {
      type: 'job',
      itemKey: 8,
      engText: 'ETC',
      text: '기타',
      flexRatio: 5
    }
  ],
  age: [
    {
      type: 'age',
      itemKey: -1,
      text: '모두',
      flexRatio: 5
    },
    {
      type: 'age',
      itemKey: 0,
      text: '0~10세',
      flexRatio: 5
    },
    {
      type: 'age',
      itemKey: 1,
      text: '11~20세',
      flexRatio: 5
    },
    {
      type: 'age',
      itemKey: 2,
      text: '21~30세',
      flexRatio: 5
    },
    {
      type: 'age',
      itemKey: 3,
      text: '31~40세',
      flexRatio: 5
    },
    {
      type: 'age',
      itemKey: 4,
      text: '41~50세',
      flexRatio: 5
    },
    {
      type: 'age',
      itemKey: 5,
      text: '51세 이상',
      flexRatio: 5
    }
  ],
  reward: [
    {
      type: 'reward',
      itemKey: 'COUPON',
      text: '쿠폰',
      flexRatio: 3
    },
    {
      type: 'reward',
      itemKey: 'POLLIDE_POINT',
      text: '폴라이드포인트',
      flexRatio: 3
    }
  ],
  mapFragInfo: [
    {
      type: '충청북도',
      top: '25%',
      left: '42%',
      fileName: 'chungcheongbuk-do.png'
    },
    {
      type: '강원도',
      top: '14%',
      left: '50%',
      fileName: 'gangwon-do.png'
    },
    {
      type: '충청남도',
      top: '31%',
      left: '24%',
      fileName: 'chungcheongnam-do.png'
    },
    {
      type: '경상북도',
      top: '34%',
      left: '57%',
      fileName: 'gyeongsangbuk-do.png'
    },
    {
      type: '전라남도',
      top: '61%',
      left: '25%',
      fileName: 'jeollanam-do.png'
    },
    {
      type: '경기도',
      top: '6%',
      left: '27%',
      fileName: 'gyeonggi-do.png'
    },
    {
      type: '제주특별자치도',
      top: '75%',
      left: '19%',
      fileName: 'jeju-do.png'
    },
    {
      type: '전라북도',
      top: '47%',
      left: '33%',
      fileName: 'jeollabuk-do.png'
    },
    {
      type: '서울특별시',
      top: '11%',
      left: '28%',
      fileName: 'seoul.png'
    },
    {
      type: '경상남도',
      top: '51%',
      left: '51%',
      fileName: 'gyeongsangnam-do.png'
    },
    {
      type: '대구광역시',
      top: '39%',
      left: '59%',
      fileName: 'daegu.png'
    },
    {
      type: '부산광역시',
      top: '51%',
      left: '68%',
      fileName: 'busan.png'
    },
    {
      type: '광주광역시',
      top: '50%',
      left: '25%',
      fileName: 'gwangju.png'
    },
    {
      type: '울산광역시',
      top: '44%',
      left: '71%',
      fileName: 'ulsan.png'
    },
    {
      type: '인천광역시',
      top: '13%',
      left: '20%',
      fileName: 'incheon.png'
    },
    {
      type: '대전광역시',
      top: '28%',
      left: '31%',
      fileName: 'daejeon.png'
    },
    {
      type: '세종특별자치시',
      top: '31%',
      left: '36%',
      fileName: 'sejong.png'
    }
  ],
  signUpTosText: [
    {
      text: '회원가입 이용약관 1 세부 내용 <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br> 줄바꿈 띄어쓰기'
    },
    {
      text:
        '‘굿윌헌팅 주식회사’는 (이하 ‘회사’는) 고객님의 개인정보를 중요시하며, “정보통신망 이용촉진 및 정보보호에 관한 법률”을 준수하고 있습니다. <br>' +
        '회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. <br>' +
        '<br>' +
        '1. 회사는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)를 통하여 공지할 것입니다. <br>' +
        '<br>' +
        '2. 회사는 회원가입, 상담, 서비스 신청 등등을 위해 아래와 같은 개인정보를 수집하고 있습니다. <br>' +
        '-수집 항목: 이메일 주소, 성별, 생년월일, 출신지역, 직업, 이름, 관심사, 서비스 이용기록, 접속 로그, 쿠키, 접속 IP정보<br>' +
        '-개인정보 수집방법: 홈페이지 및 모바일 어플리케이션(회원가입, 게시판, 이벤트 응모 등), 서면양식, 전화 또는 팩스를 통한 회원가입, 이벤트 응모, 제휴사로부터의 제공, 생성정보 수집 툴을 통한 수집, 메일, 눈<br>' +
        '<br>' +
        '3. 회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다. <br>' +
        '-서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산, 콘텐츠 제공, 구매 및 요금 결제, 금융거래 본인 인증 및 금융 서비스<br>' +
        '-회원 관리 회원제 서비스 이용에 따른 본인확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 만 14세 미만 아동 개인정보 수집시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달<br>' +
        '-마케팅 및 광고에 활용, 신규 서비스(제품) 개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 대한 통계<br>' +
        '<br>' +
        '4. 개인정보 수집 및 이용목적이 달성된 후에는 원칙적으로 해당 정보를 지체없이 파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. <br>' +
        '-보존 항목: 이메일 및 주소록 정보, 서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보, 결제기록<br>' +
        '-보존 근거: 전자상거래등에서의 소비자보호에 관한 법률, 신용정보의 이용 및 보호에 관한 법률<br>' +
        '-보존 기간: 5년<br>' +
        '-표시/광고에 대한 기록: 6개월 (전자상거래등에서의 소비자보호에 관한 법률)<br>' +
        '-계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br>' +
        '-대금결제 및 재화 등의 공급에 관한 기록: 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br>' +
        '-소비자의 불만 또는 분쟁처리에 관한 기록: 3년  (전자상거래등에서의 소비자보호에 관한 법률)<br>' +
        '-신용정보의 수집/처리 및 이용 등에 관한 기록: 3년  (전자상거래등에서의 소비자보호에 관한 법률)<br>' +
        '<br>' +
        '5. 회사가 수집한 개인정보의 파기절차 및 방법은 다음과 같습니다. <br>' +
        '-파기절차: 사용자가 회원 가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 데이터베이스(종이의 경우 별도의 서류함)로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 데이터베이스(종이의 경우 별도의 서류함)로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유 되어지는 이외의 다른 목적으로 이용되지 않습니다. <br>' +
        '-파기방법: 전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다. 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다. <br>' +
        '<br>' +
        '6. 회사는 회원에 대하여 보다 더 질 높은 서비스 제공 등을 위해 제3자에게 귀하의 개인정보를 제공할 수 있습니다. <br>' +
        '-제공하는 개인정보 항목: 이메일 주소, 서비스 이용기록, 접속 로그, 결제기록<br>' +
        '-제공정보의 이용 목적: 콘텐츠 제공, 구매 및 요금 결제, 물품배송 또는 청구지 등 발송, 금융거래 본인 인증 및 금융 서비스, 요금 추심, 회원제 서비스 이용에 따른 본인 확인, 개인 식별, 불량회원의 부정 이용 방지와 비인가 사용 방지, 가입 의사 확인, 연령확인, 만14세 미만 아동 개인정보 수집 시 법정 대리인 동의여부 확인, 불만처리 등 민원처리, 고지사항 전달, 신규 서비스(제품)개발 및 특화, 이벤트 등 광고성 정보 전달, 인구통계학적 특성에 따른 서비스 제공 및 광고 게재, 접속 빈도 파악 또는 회원의 서비스 이용에 따른 통계<br>' +
        '-제공 정보의 보유 및 이용 기간: 5년<br>' +
        '<br>' +
        '7. 사용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며, 가입해지를 요청할 수 도 있습니다. <br>' +
        '-사용자 혹은 만 14세 미만 아동의 개인정보 조회 또는 수정을 위해서는 ‘개인정보변경’(또는 ‘회원정보수정’등)을 회원 가입 해지(탈퇴)를 위해서는 “회원탈퇴”를 클릭하여 소정의 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. <br>' +
        '-개인정보관리책임자에게 서면, 전화 또는 이메일을 통한 방법으로도 회원 가입 해지가 가능합니다. <br>' +
        '-사용자가 개인정보의 오류에 대한 정정을 요청한 경우, 정정을 완료하기 전까지 해당 개인정보를 이용 또는 제공하지 않으며, 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 회사는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 최선을 다합니다. <br>' +
        '-사용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 “굿윌헌팅 주식회사”가 수집하는 개인정보의 보유 및 이용기간에 명시된 바에 따라 처리하고, 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다. <br>' +
        '<br>' +
        '8. 회사는 귀하의 정보를 수시로 저장하고 찾아내는 ‘쿠키(cookie)’등을 운용합니다. 쿠키란 웹사이트를 운영하는데 이용되는 서버가 사용자의 브라우저에 보내는 아주 작은 텍스트 파일로서, 사용자의 컴퓨터 하드디스크 도는 스마트폰에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키를 사용합니다. <br>' +
        '-쿠키 등 사용 목적: 회원과 비회원의 접속 빈도나 방문 시간 등을 분석, 사용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공<br>' +
        '-사용자는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 사용자는 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수도 있습니다. <br>' +
        '-쿠키 설정 거부 방법: 사용자가 웹브라우저의 설정을 변경함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수도 있습니다. 단, 사용자가 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다. <br>' +
        '<br>' +
        '9. 회사는 사용자의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다. <br>' +
        '-정보처리담당부서: 정보팀<br>' +
        '-전화번호: 02-2039-0623<br>' +
        '-이메일:goodwill@gwh.co.kr<br>' +
        '-개인정보관리책임자 성명: 박성용<br>' +
        '<br>' +
        '10. 사용자는 회사의 서비스를 이용하면서 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 또는 담당부서로 신고할 수 있습니다. 회사는 사용자등ㄹ의 신고사항에 대해 신속하게 충분한 답변을 제공하도록 최선을 다합니다. 기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래기관에 문의하시기 바랍니다. <br>' +
        '-개인정보침해신고센터 (www.1336.or.kr/국번없이118)<br>' +
        '-정보보호마크인증위원회 (www.eprivacy.or.kr/02-580-0533~4)<br>' +
        '-대검찰청 인터넷범죄수사센터 (http://icic.sppo.go.kr/02-3480-3600)<br>' +
        '-경찰청 사이버테러대응센터 (www.ctrc.go.kr/02-392-0330)'
    },
    {
      text: '회원가입 이용약관 3 세부 내용'
    },
    {
      text: '회원가입 이용약관 4 세부 내용'
    }
  ],
  paymentTosText: '회원가입 약관 세부내용 <br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br><br> 줄바꿈 띄어쓰기'

}



// WEBPACK FOOTER //
// ./src/params.js